import { useCallback, useEffect, useState } from 'react';
import { Image } from 'components/elements/image/Image';
import { Wrapper, ImageWrapper, Info } from './ErrorPageContent.styles';
import { usePolyglotT } from 'utils/locale/locale';
import { Heading } from 'components/elements/heading/Heading';
import { Paragraph } from 'components/elements/paragraph/Paragraph';
import { Button } from 'components/elements/button/Button';
import { useSessionContext } from 'utils/context/session-provider';
import { getRedirectURLFromClientID } from 'utils/helpers';
import { Card } from 'components/elements/card/Card';
import { useRouter } from 'next/router';

export const ErrorPageContent = () => {
  const router = useRouter();

  const { t } = usePolyglotT();
  const { clientId, redirectBackToClient } = useSessionContext();

  const redirectUri = router?.query?.redirect_uri as string;
  const [redirectURL, setRedirectURL] = useState<string | undefined>(
    getRedirectURLFromClientID(clientId, redirectUri)
  );

  useEffect(() => {
    setRedirectURL(getRedirectURLFromClientID(clientId, redirectUri));
  }, [clientId, redirectUri]);

  const onClick = useCallback(() => {
    redirectBackToClient();
  }, []);

  return (
    <Wrapper>
      <Card>
        <ImageWrapper>
          <Image
            src='/images/error-image.svg'
            alt={t('error_page.image_alt')}
            fill
          />
        </ImageWrapper>
        <Info>
          <Heading>{t('error_page.heading')}</Heading>
          <Paragraph>{t('error_page.description')}</Paragraph>
          {redirectURL && (
            <Button onClick={onClick} isFull data-testid='back-button'>
              {t('error_page.button')}
            </Button>
          )}
        </Info>
      </Card>
    </Wrapper>
  );
};
